import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemeService } from 'src/app/theme/theme-service.service';

@Component({
    selector: 'app-delegate-summary',
    templateUrl: './delegate-summary.component.html',
    styleUrls: ['./delegate-summary.component.scss'],
    standalone: false
})
export class DelegateSummaryComponent implements OnInit {

  @Input() public delegate;
  @Output() public delegateUpdated$: EventEmitter<Object> = new EventEmitter<Object>();

  public statusDynamicCollapse;
  public
  constructor(public themeService: ThemeService) { }

  ngOnInit() {

  }

  save() {
    this.delegateUpdated$.emit(this.delegate);
  }

}
